import { navigate, withPrefix } from "gatsby";
import * as React from "react";
import { useCallback, useContext, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import DropdownButton from "react-bootstrap/DropdownButton";
import { Helmet } from "react-helmet";
import Select from "react-select";
import { AppContext } from "../../../context/appContext";
import "./Database.scss";

export const DatabaseMap = () => {
  // Keep the function reference
  const setWindowParams = useCallback(() => {
    const mapjsTag = document.createElement("script");
    // given the js/main.js file is put in the static folder
    mapjsTag.src = withPrefix("maps/databasemap.js");

    document.body.appendChild(mapjsTag);
  }, []);

  const countryData = useContext(AppContext)?.allNodeCountryProfile?.nodes;
  useEffect(() => {
    setWindowParams();
  }, [setWindowParams]);

  const handleCountryChange = (e) => {
    navigate(e?.path?.alias);
  };

  return (
    <>
      <Helmet>
        <script src={withPrefix("maps/amcharts/amcharts.js")}></script>
        <script src={withPrefix("maps/ammap/ammap.js")}></script>
        <script src={withPrefix("maps/amcharts/xy.js")}></script>
        <script src={withPrefix("maps/amcharts/serial.js")}></script>
        <script src={withPrefix("maps/amcharts/themes/light.js")}></script>
        <script
          src={withPrefix("maps/amcharts/plugins/export/export.min.js")}
        ></script>
        <script
          src={withPrefix("maps/amcharts/plugins/dataloader/dataloader.js")}
        ></script>
        <script
          src={withPrefix("maps/amcharts/plugins/responsive/responsive.js")}
        ></script>
        <script
          src={withPrefix(
            "maps/amcharts/plugins/export/libs/fabric.js/fabric.min.js"
          )}
        ></script>
        <script
          src={withPrefix(
            "maps/amcharts/plugins/export/libs/FileSaver.js/FileSaver.min.js"
          )}
        ></script>
        <script
          src={withPrefix("maps/amcharts/plugins/export/libs/jszip/jszip.js")}
        ></script>
        <script
          src={withPrefix(
            "maps/amcharts/plugins/export/libs/pdfmake/pdfmake.min.js"
          )}
        ></script>
        <script
          src={withPrefix("maps/libs/pdfmake/0.1.36/vfs_fonts.js")}
        ></script>
        <script
          src={withPrefix("maps/amcharts/plugins/export/libs/xlsx/xlsx.js")}
        ></script>
        <script src={withPrefix("maps/idmcscript/roundnumber.js")}></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/wow/1.1.2/wow.min.js"></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/countup.js/1.9.3/countUp.min.js"></script>
        <script src={withPrefix("maps/wowinit.js")}></script>
        <link
          rel="stylesheet"
          href={withPrefix("/maps/amcharts/plugins/export/export.css")}
        />
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.2/animate.min.css"
        />
        <link
          rel="stylesheet"
          href={withPrefix("maps/assets/myf_2019.css")}
        ></link>
        <style type="text/css">
          {`
            #mapdiv_id{
              height: 540px;
              display: inline-block;
              width: 100%;
            }
            `}
        </style>
      </Helmet>
      <Container className="database-map-container general-container p-0 country">
        <Row className="m-0 country-map mb-4 w-auto">
          <div id="mapdiv_id" className="containter p-0"></div>
          <div className="country-select">
            <DropdownButton
              id="dropdown-basic-button"
              title="Select Country"
              bsPrefix="custom-dropdown"
            >
              <Select
                classNamePrefix="react-select"
                options={countryData}
                getOptionLabel={(item) => item?.title}
                menuIsOpen={true}
                onChange={(e) => {
                  handleCountryChange(e);
                }}
                placeholder={"Type here..."}
                isSearchable={true}
                components={{
                  DropdownIndicator: () => null,
                  IndicatorSeparator: () => null,
                }}
              ></Select>
            </DropdownButton>
          </div>
        </Row>
      </Container>
    </>
  );
};
